// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@conklin/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@conklin/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain as LoadProductInfoListChain,
    LoadRealTimeInventory,
} from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

const _GaTrackViewItemList: typeof LoadRealTimeInventory = props => {
    setTimeout(() => {
        const dataLayer = getDataLayer();
        const state = props.getState() as xGoogleAnalyticsState;
        const productInfos = state.components.productInfoLists.productInfoListById[props.parameter.id];
        const currencyCode = state.context?.session?.currency?.currencyCode;

        if (dataLayer && productInfos?.productInfoByProductId && props.products?.length) {
            const isDuplicateEvent = dataLayer.find(
                (d: any) =>
                    d.event === state.xGoogleAnalytics?.productImpressionEventName &&
                    d.ecommerce.item_list_id === props.parameter.id,
            );

            if (state.xGoogleAnalytics?.productImpressionEvent && !isDuplicateEvent) {
                const googleAnalyticsData = {
                    event: state.xGoogleAnalytics?.productImpressionEventName,
                    ecommerce: {
                        item_list_id: props.parameter.id,
                        item_list_name: "Product Carousel",
                        currency: currencyCode,
                        items: [] as any,
                    },
                };

                props.products?.forEach((product, idx) => {
                    const productInfo = productInfos.productInfoByProductId[product.id];

                    googleAnalyticsData.ecommerce.items.push({
                        item_name: product?.productTitle,
                        item_id: product?.productNumber,
                        price: productInfo?.pricing?.unitNetPrice,
                        index: idx,
                        item_brand: state.xGoogleAnalytics["includeProductBrand"]
                            ? product?.brand?.name || ""
                            : undefined,
                        item_category: state.xGoogleAnalytics["includeProductCategory"]
                            ? product?.properties?.["category"] || ""
                            : undefined,
                        item_list_id: state.xGoogleAnalytics["includeProductCategory"]
                            ? product?.properties?.["categoryId"] || ""
                            : undefined,
                    });
                });

                dataLayer.push(googleAnalyticsData);
            }
        }
    }, 1000);
};

addToEndOfChain(LoadProductInfoListChain, _GaTrackViewItemList);
